export const newsArticles = [
  {
    id: 1,
    title: "Nuevas Regulaciones Aduaneras 2024",
    date: "15 de Julio, 2024",
    excerpt: "Descubre los cambios más importantes en las regulaciones aduaneras que impactarán tus operaciones este año."
  },
  {
    id: 2,
    title: "Optimización de Procesos con Anexo 24",
    date: "10 de Julio, 2024",
    excerpt: "Conoce cómo la correcta implementación del Anexo 24 puede reducir costos y mejorar la eficiencia de tu inventario."
  },
  {
    id: 3,
    title: "Tendencias en Logística Internacional",
    date: "05 de Julio, 2024",
    excerpt: "Exploramos las tendencias emergentes en logística y transporte que están transformando el comercio global."
  },
  {
    id: 4,
    title: "VUCEM: Digitalización y Eficiencia",
    date: "01 de Julio, 2024",
    excerpt: "La Ventanilla Única de Comercio Exterior Mexicana sigue evolucionando. Te contamos las últimas actualizaciones."
  }
];